import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';

const VehiclePlateLetterModal = ({
  options,
  onClick,
}: {
  options: { id: string; letter: string }[];
  onClick: (value: string) => void;
}) => {
  return (
    <Box
      display="flex"
      gap="2em"
      alignItems="center"
      flexWrap="wrap"
      my="3rem"
      justifyContent="space-between"
    >
      {options.map((item) => {
        return (
          <Typography
            cursor="pointer"
            onClick={() => onClick(item.letter)}
            textAlign="center"
            minWidth="20px"
            key={item.id}
            color="black"
            textStyle="b1"
          >
            {item.letter}
          </Typography>
        );
      })}
    </Box>
  );
};

export default VehiclePlateLetterModal;
